// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bulk Render Modal Styles */

.bulk-render-modal {
  max-width: 600px;
  width: 95vw;
  max-height: 85vh;
  overflow-y: auto;
}

.bulk-render-modal .modal-body {
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
}

.bulk-render-modal h2 {
  color: #333;
  font-size: 24px;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.confirmation-section {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Info Section */
.info-section h3 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.render-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info-label {
  font-weight: 500;
  color: #6c757d;
}

.info-value {
  font-weight: 600;
  color: #333;
  text-align: right;
}

/* Sync Section */
.sync-section h3 {
  margin: 0 0 8px 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.sync-description {
  margin: 0 0 16px 0;
  color: #6c757d;
  font-size: 14px;
  line-height: 1.4;
}

.sync-toggle {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

/* Switch Styles */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 24px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #007bff;
}

input:focus + .slider {
  box-shadow: 0 0 1px #007bff;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.toggle-label {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

/* Sync Warning */
.sync-warning {
  display: flex;
  gap: 12px;
  padding: 12px;
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 6px;
}

.warning-icon {
  font-size: 20px;
  flex-shrink: 0;
}

.warning-text {
  font-size: 14px;
  color: #856404;
  line-height: 1.4;
}

/* Process Info */
.process-info h3 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.process-steps {
  margin: 0;
  padding-left: 20px;
  color: #333;
}

.process-steps li {
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.4;
}

/* Warning Section */
.warning-section {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: #d4edda;
  border: 1px solid #c3e6cb;
  border-radius: 6px;
}

.warning-section .warning-icon {
  font-size: 24px;
  flex-shrink: 0;
}

.warning-section .warning-text {
  color: #155724;
  font-size: 14px;
  line-height: 1.4;
}

/* Modal Footer */
.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px;
  border-top: 1px solid #eee;
}

.modal-cancel-button {
  padding: 10px 20px;
  border: 1px solid #6c757d;
  background: white;
  color: #6c757d;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.modal-cancel-button:hover:not(:disabled) {
  background: #6c757d;
  color: white;
}

.modal-confirm-button {
  padding: 10px 20px;
  border: none;
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.modal-confirm-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #0056b3, #004085);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
}

.modal-confirm-button:disabled {
  background: #6c757d;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.loading-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Responsive Design */
@media (max-width: 768px) {
  .bulk-render-modal {
    width: 98vw;
    max-width: none;
    max-height: 90vh;
  }

  .bulk-render-modal .modal-body {
    padding: 16px;
    max-height: 75vh;
  }

  .confirmation-section {
    gap: 20px;
  }

  .render-info {
    padding: 12px;
  }

  .info-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .info-value {
    text-align: left;
  }

  .sync-toggle {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .modal-footer {
    flex-direction: column-reverse;
    gap: 8px;
  }

  .modal-cancel-button,
  .modal-confirm-button {
    width: 100%;
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/BulkRenderModal.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":["/* Bulk Render Modal Styles */\n\n.bulk-render-modal {\n  max-width: 600px;\n  width: 95vw;\n  max-height: 85vh;\n  overflow-y: auto;\n}\n\n.bulk-render-modal .modal-body {\n  padding: 20px;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.bulk-render-modal h2 {\n  color: #333;\n  font-size: 24px;\n  margin-bottom: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.confirmation-section {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* Info Section */\n.info-section h3 {\n  margin: 0 0 12px 0;\n  color: #333;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.render-info {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background: #f8f9fa;\n  padding: 16px;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.info-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.info-label {\n  font-weight: 500;\n  color: #6c757d;\n}\n\n.info-value {\n  font-weight: 600;\n  color: #333;\n  text-align: right;\n}\n\n/* Sync Section */\n.sync-section h3 {\n  margin: 0 0 8px 0;\n  color: #333;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.sync-description {\n  margin: 0 0 16px 0;\n  color: #6c757d;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.sync-toggle {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n/* Switch Styles */\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 24px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: .4s;\n  border-radius: 24px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: .4s;\n  border-radius: 50%;\n}\n\ninput:checked + .slider {\n  background-color: #007bff;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #007bff;\n}\n\ninput:checked + .slider:before {\n  transform: translateX(26px);\n}\n\n.toggle-label {\n  font-size: 16px;\n  font-weight: 500;\n  color: #333;\n}\n\n/* Sync Warning */\n.sync-warning {\n  display: flex;\n  gap: 12px;\n  padding: 12px;\n  background: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 6px;\n}\n\n.warning-icon {\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.warning-text {\n  font-size: 14px;\n  color: #856404;\n  line-height: 1.4;\n}\n\n/* Process Info */\n.process-info h3 {\n  margin: 0 0 12px 0;\n  color: #333;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.process-steps {\n  margin: 0;\n  padding-left: 20px;\n  color: #333;\n}\n\n.process-steps li {\n  margin-bottom: 8px;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n/* Warning Section */\n.warning-section {\n  display: flex;\n  gap: 12px;\n  padding: 16px;\n  background: #d4edda;\n  border: 1px solid #c3e6cb;\n  border-radius: 6px;\n}\n\n.warning-section .warning-icon {\n  font-size: 24px;\n  flex-shrink: 0;\n}\n\n.warning-section .warning-text {\n  color: #155724;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n/* Modal Footer */\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 20px;\n  border-top: 1px solid #eee;\n}\n\n.modal-cancel-button {\n  padding: 10px 20px;\n  border: 1px solid #6c757d;\n  background: white;\n  color: #6c757d;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.modal-cancel-button:hover:not(:disabled) {\n  background: #6c757d;\n  color: white;\n}\n\n.modal-confirm-button {\n  padding: 10px 20px;\n  border: none;\n  background: linear-gradient(135deg, #007bff, #0056b3);\n  color: white;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.modal-confirm-button:hover:not(:disabled) {\n  background: linear-gradient(135deg, #0056b3, #004085);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);\n}\n\n.modal-confirm-button:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.loading-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid transparent;\n  border-top: 2px solid white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .bulk-render-modal {\n    width: 98vw;\n    max-width: none;\n    max-height: 90vh;\n  }\n\n  .bulk-render-modal .modal-body {\n    padding: 16px;\n    max-height: 75vh;\n  }\n\n  .confirmation-section {\n    gap: 20px;\n  }\n\n  .render-info {\n    padding: 12px;\n  }\n\n  .info-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n\n  .info-value {\n    text-align: left;\n  }\n\n  .sync-toggle {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .modal-footer {\n    flex-direction: column-reverse;\n    gap: 8px;\n  }\n\n  .modal-cancel-button,\n  .modal-confirm-button {\n    width: 100%;\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
